import { Component } from "react"
import React from "react";
import FormError from "../../../../models/FormError";
import InputField from "../../../../views/components/InputField.Component";
import ContactFormConfiguration from "../../models/ContactFormConfiguration";
import DateInputField from "../../../../views/components/DateInputField.Component";
import ContactFormEntry from "../../models/ContactFormEntry";

type PersonalInfoExistingCustomerViewProps = {
    errors: FormError[],
    configuration: ContactFormConfiguration,
    onChange: (propertyName: string, value: string) => Promise<FormError[]>
    onDateOfBirthSet: (propertyName: string, value: Date) => Promise<FormError[]>
    initialValues: ContactFormEntry
}

export default class PersonalInfoExistingCustomerView extends Component<PersonalInfoExistingCustomerViewProps> {
    render() {
        return (<>
            <InputField id="personalinfoexisting-customerNumber" name="customerNumber" placeholder={this.props.configuration.customerNumberPlaceholder} label={this.props.configuration.customerNumberLabel} onChange={this.props.onChange.bind(this)} errors={this.props.errors} initialValue={this.props.initialValues.customerNumber} ></InputField>
            <div className="text-medium mt-1 mb-2" dangerouslySetInnerHTML={{ __html: this.props.configuration.customerNumberAdditionalInformation }}></div>
            <DateInputField id="personalinfoexisting-dateOfBirth" autocomplete="bday" name="dateOfBirth" placeholder={this.props.configuration.dayOfBirthPlaceholder} label={this.props.configuration.dayOfBirthLabel} onChange={this.props.onDateOfBirthSet.bind(this)} errors={this.props.errors} value={this.props.initialValues.dateOfBirth?.toString()}></DateInputField>
        </>);
    }
}